import { useRef, useState } from 'react';
import { Container as MapDiv, NaverMap } from 'react-naver-maps';
import { Outlet } from 'react-router';
import { SearchBarButton as MapSearchBar } from '@/features/station-search';
import { FUEL_TYPE_OPTION } from '@/shared/consts';
import { useLocation } from '@/shared/lib';
import { useBoundStore } from '@/shared/store';
import {
	NaverMapMyLocationButton,
	NaverMapStationFetcher,
	NaverMapStationMarker,
	NaverMapUserMarker,
	NaverMapZoomGuide,
	PlaceMarker,
	useMapFitRadius,
	useNaverMapStore,
} from '@/widgets/naver-map';
import { Navigation } from '@/widgets/navigation';

const HomePage = () => {
	const setCurrentZoomLevel = useNaverMapStore(
		(store) => store.setCurrentZoomLevel,
	);
	const selectedPlace = useBoundStore((store) => store.selectedPlace);
	const setSelectedPlace = useBoundStore((store) => store.setSelectedPlace);

	const [selectedFuelType, setSelectedFuelType] = useState<
		(typeof FUEL_TYPE_OPTION)[number]['value']
	>(FUEL_TYPE_OPTION[0].value);
	const { location, isLocationPermissionDenied } = useLocation();
	const initialMapCenter = selectedPlace ?? location;

	const mapRef = useRef<naver.maps.Map>(null);
	useMapFitRadius(
		mapRef.current,
		5,
		initialMapCenter?.lat,
		initialMapCenter?.lng,
	);

	const handleMapDragEnd = () => {
		setSelectedPlace(null);
	};

	return (
		<div className="relative flex h-dvh w-full flex-col">
			<MapSearchBar
				onSelectFuelType={(fuelType) => setSelectedFuelType(fuelType)}
				selectedFuelType={selectedFuelType}
			/>
			<MapDiv
				style={{
					width: '100%',
					height: '100%',
					flex: 1,
					position: 'relative',
				}}
			>
				<NaverMap
					ref={mapRef}
					onZoomChanged={(zoom) => setCurrentZoomLevel(zoom)}
					onDragend={handleMapDragEnd}
				>
					<NaverMapStationFetcher fuelType={selectedFuelType} />
					<NaverMapMyLocationButton
						latitude={location?.lat}
						longitude={location?.lng}
						isLocationPermissionDenied={isLocationPermissionDenied}
					/>
					<NaverMapUserMarker
						latitude={location?.lat}
						longitude={location?.lng}
					/>
					<NaverMapStationMarker />
					<NaverMapZoomGuide />
					{selectedPlace && (
						<PlaceMarker lat={selectedPlace.lat} lng={selectedPlace.lng} />
					)}
				</NaverMap>
			</MapDiv>
			<Outlet />
			<Navigation />
		</div>
	);
};

export default HomePage;
